import { render, staticRenderFns } from "./MyDossiersFilters.vue?vue&type=template&id=23d06dde&scoped=true"
import script from "./MyDossiersFilters.vue?vue&type=script&lang=ts"
export * from "./MyDossiersFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d06dde",
  null
  
)

export default component.exports